import React from 'react';
import { T, fontBody } from '../tokens';

export default function ValidationMessages({ errors }) {
  const entries = Object.entries(errors || {});
  if (!entries.length) return null;

  return (
    <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 6 }}>
      {entries.map(([key, message]) => (
        <div
          key={key}
          style={{
            fontFamily: fontBody,
            fontSize: 12,
            color: '#991B1B',
            background: '#FEE2E2',
            padding: '8px 10px',
            borderRadius: 8,
          }}
        >
          {message}
        </div>
      ))}
    </div>
  );
}
